import React from "react";
import PropTypes from "prop-types";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function ActiveDemeritCompanyWarning({ company }) {
  if (company && company.demerits >= 4) {
    return (
      <Warning>
        Due to 4 or more Active Demerits within the last 24 months, this Vendor
        will require QC Pre-Approval. A notification will be sent to QC for
        Pre-approval
      </Warning>
    );
  }

  return null;
}

ActiveDemeritCompanyWarning.propTypes = {
  company: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/ActiveDemeritCompanyWarning.jsx